(() => {
  if (window.__velzeenOfferCopyLoadedV2) return;
  window.__velzeenOfferCopyLoadedV2 = true;

  const timers = new WeakMap();
  const COPY_BUTTON_SELECTOR = '[data-vz-copy-code], .vz-offer-card__copy';
  const RESTORE_DELAY = 2600;

  function getCode(button) {
    const direct = button.getAttribute('data-vz-copy-code');
    if (direct) return direct.trim();

    const buttonText = String(button.textContent || '').replace(/^copy\s*/i, '').trim();
    if (buttonText && !/^copied$/i.test(buttonText)) return buttonText;

    const card = button.closest('[data-vz-offer-card]');
    const codeElement = card?.querySelector('[data-vz-offer-code], .vz-offer-card__code, .vz-offer-card__main h2');
    return String(codeElement?.textContent || '').trim() || 'SAVE50';
  }

  function copyLabel(code) {
    return code ? 'COPY ' + code : 'COPY SAVE50';
  }

  function markCopied(button, code) {
    window.clearTimeout(timers.get(button));
    button.textContent = 'Copied';
    button.setAttribute('aria-label', 'Coupon copied');
    button.classList.add('is-copied');
    button.dataset.vzCopyState = 'copied';

    const timer = window.setTimeout(() => {
      button.textContent = copyLabel(code);
      button.setAttribute('aria-label', code ? 'Copy coupon ' + code : 'Copy coupon');
      button.classList.remove('is-copied');
      button.dataset.vzCopyState = 'idle';
      timers.delete(button);
    }, RESTORE_DELAY);

    timers.set(button, timer);
  }

  function fallbackCopy(text) {
    const field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', 'readonly');
    field.style.position = 'fixed';
    field.style.left = '-9999px';
    field.style.top = '0';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.focus();
    field.select();
    field.setSelectionRange(0, field.value.length);

    let copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (error) {
      copied = false;
    }

    document.body.removeChild(field);
    return copied;
  }

  async function copyCode(text) {
    if (!text) return false;

    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (error) {}
    }

    return fallbackCopy(text);
  }

  function handleCopy(event) {
    const button = event.target.closest?.(COPY_BUTTON_SELECTOR);
    if (!button) return;

    const code = getCode(button);
    if (!code) return;

    event.preventDefault();
    markCopied(button, code);
    copyCode(code).catch(() => {});
  }

  document.addEventListener('click', handleCopy, true);
})();
